import React from "react";
import { colors, fontMono } from "../lib/theme";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Queda también en la consola del navegador para poder copiarlo
    console.error("Centinel DX — error capturado:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, maxWidth: 700, margin: "0 auto" }}>
          <h1 style={{ color: colors.text, fontSize: 22, marginBottom: 10 }}>Algo ha fallado en esta pantalla</h1>
          <p style={{ color: colors.textDim, marginBottom: 16 }}>
            Copia el siguiente mensaje y compártelo para poder arreglarlo:
          </p>
          <pre style={{
            background: colors.panel, border: `1px solid ${colors.lineStrong}`, borderRadius: 8,
            padding: 16, color: "#ffb4b4", fontFamily: fontMono, fontSize: 12.5, whiteSpace: "pre-wrap",
          }}>
            {String(this.state.error?.stack || this.state.error)}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: 16, background: colors.amber, color: colors.void, border: "none", borderRadius: 6, fontWeight: 700, padding: "10px 18px", cursor: "pointer" }}
          >
            Recargar la página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
